<div class="device-card" [class.selected]="isSelected" [class.online]="isOnline" [class.offline]="!isOnline" (click)="onDeviceClick()">
  <span class="device image-outer">
    <img class="device-image" [src]="getImageUrl(device?.device_model_id ? device?.device_model_id : device?.model)" alt="{{device?.model}} product image"/>
  </span>
    <div>
        <div class="card-text">

            <div class="device-status" *ngIf="device?.status === 'online'; else deviceOffline">
                <h5>{{ device?.name }}</h5>
                <div class="status-indicator">
                    <div class="status-icon online"></div>
                    <div class="small list-group-item">Online</div>
                </div>
            </div>
            <!-- Offline status with red circle -->
            <ng-template #deviceOffline class="device-status">
                <div class="device-status">
                    <h5>{{ device?.name }}</h5>
                    <div class="status-indicator">
                        <div class="status-icon offline"></div>
                        <div class="small list-group-item">Offline</div>
                    </div>
                </div>
            </ng-template>

            <div *ngIf="device?.model" class="small list-group-item align-items-center" aria-description="model number">
                <img width="16" height="16" ngSrc="assets/images/icons/box-fill.svg" alt="Model Number" aria-hidden="true" class="device-icon">
                Model: {{ device?.model }}
            </div>

            <div *ngIf="device?.id" class="small list-group-item align-items-center">
                <img width="16" height="16" ngSrc="assets/images/icons/upc-scan.svg" alt="Device ID" aria-hidden="true" class="device-icon">
                ID: {{ device?.id }}
            </div>

            <div *ngIf="device?.subscription" class="small list-group-item align-items-center">
                <img width="16" height="16" ngSrc="assets/images/icons/shield-check.svg" alt="Protected" aria-hidden="true" class="device-icon">
                Cloud Enabled
            </div>

            <div *ngIf="!device?.owner" class="small list-group-item align-items-center">
                <img width="16" height="16" ngSrc="assets/images/icons/people-fill.svg" alt="Shared" aria-hidden="true" class="device-icon">
                Shared Device
            </div>


        </div>
    </div>
</div>

<ng-template #deviceOffline>Offline</ng-template>